// extracted by mini-css-extract-plugin
module.exports = {"btn":"ActionButton_btn__11Xky","text":"ActionButton_text__3wZQA"};